import PointsOfSaleServices from "@/services/PointOfSale";
import GenericServices from "@/services/Generic";
import WarehousesServices from "@/services/Warehouse";
import helpers from "@/helpers.js";
import CategoriesServices from "@/services/Category";
import warehouseKartelaForm from "./kartela";

export default async function editWarehouse(wa) {
  var city = await PointsOfSaleServices.getCities();
  var contact_details = await GenericServices.getDetailsTypes({ related_entity: "warehouse" });
  var main_unit = await WarehousesServices.getWarehouseMainUnits();
  var facility = await WarehousesServices.getWarehouseFacilities();
  var warehouse_categories = helpers.toTree(await CategoriesServices.getCategories("warehouses"), "id");

  var warehouses = await WarehousesServices.getWarehouses();
  var warehouse_transit_list = warehouses.filter((ware) => ware.gathering_point == 1 && ware.guid != wa.guid);
  warehouse_transit_list = helpers.toTree(warehouse_transit_list, "id");

  var single_warehouse_transits = await WarehousesServices.getSingleWarehouseTransit(wa);
  if (!wa.transit_warehouses) wa.transit_warehouses = [];
  single_warehouse_transits.map((gw) => {
    wa.transit_warehouses.push(gw);
  });
  var selected_transit_warehouses = {};
  if (wa.transit_warehouses && wa.transit_warehouses.length > 0) {
    wa.transit_warehouses.map((tw) => {
      selected_transit_warehouses[tw.transit_warehouse] = tw.transit_warehouse_name;
    });
  }

  var users = await PointsOfSaleServices.getUsers();
  var roles = [];
  var priority_order = [];

  roles.unshift({ label: "Primar", id: 1 }, { label: "Sekondar", id: 2 });
  priority_order.unshift({ label: "Rendi Kryesor", id: 1 }, { label: "Rendi 2", id: 2 }, { label: "Rendi 3", id: 3 });

  var warehouses_selected_categories = {};
  warehouses_selected_categories[wa.type_id] = wa.type_id_name;

  return warehouseKartelaForm({
    mode: "edit",
    wa,
    cities: city,
    contact_details,
    main_unit,
    facility,
    warehouses,
    warehouse_categories,
    warehouses_selected_categories,
    warehouse_transit: warehouse_transit_list,
    selected_transit_warehouses,
    users,
    roles,
    priority_order,
  });
}
